<template>
  <b-table
      :fields="fields"
      :items="items"
      table-class="text-nowrap"
      responsive
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
  >
    <template #cell(name)="data">
      <div class="d-flex align-items-center">
        <div v-if="data.item.brand.logo_url" class="mr-2">
          <b-avatar variant="primary" :src="data.item.brand.logo_url" size="40px"/>
        </div>
        <div>
          <h4 class="mb-0">{{ data.item.brand.name }}</h4>
        </div>
      </div>
    </template>
    <template #cell(created_by)="data">
      <b-link
          :to="{name: 'admin-user', params: {id: data.item.brand.created_by.id.toString()}}"
      >
        {{ data.item.brand.created_by.name }}
      </b-link>
    </template>
    <template #cell(created_on)="data">
      {{ convertFromUtc(data.item.created_on, "MM/DD/YYYY") }}
    </template>
    <template #cell(status)="data">
      <b-badge v-if="data.item.brand.is_approved" variant="success">Approved</b-badge>
      <b-badge v-else variant="danger">Not Approved</b-badge>
    </template>
    <template #cell(actions)="data">
      <no-permission-wrapper :show="!canApproveBrands">
        <b-btn
            v-if="!data.item.brand.is_approved"
            variant="success"
            @click.prevent="$emit('approve', data.item.brand)"
            :disabled="!canApproveBrands"
        >
          Approve
        </b-btn>
      </no-permission-wrapper>
      <no-permission-wrapper :show="!canDeleteBrands">
        <b-btn
            variant="danger"
            @click.prevent="$emit('delete', data.item.brand)"
            :disabled="!canDeleteBrands"
        >
          Delete
        </b-btn>
      </no-permission-wrapper>
    </template>

  </b-table>
</template>

<script>
import {convertFromUtc} from "../helpers";
import NoPermissionWrapper from "./NoPermissionWrapper.vue";

export default {
  name: "AdminBrandsTable",
  components: {NoPermissionWrapper},
  methods: {convertFromUtc},
  props: {
    brands: {
      type: Array,
      required: true
    }
  },
  emits: ['approve', 'delete'],
  data() {
    return {
      sortBy: 'created_on',
      sortDesc: true,
      fields: [
        {
          key: "name",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "status",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "created_on",
          thClass: "border-top-0",
          tdClass: "align-middle",
          sortable: true
        },
        {
          key: "created_by",
          thClass: "border-top-0",
          tdClass: "align-middle"
        },
        {
          key: "actions",
          thClass: "border-top-0",
          tdClass: "align-middle"
        }
      ]
    }
  },
  computed: {
    canApproveBrands() {
      return this.$store.getters['auth/hasAdminPermissions']('brand_approve');
    },
    canDeleteBrands() {
      return this.$store.getters['auth/hasAdminPermissions']('brand_delete');
    },
    items() {
      return this.brands.map(brand => ({
        brand: brand,
        name: brand.name,
        created_on: brand.created_at//convertFromUtc(brand.created_at, "MM/DD/YYYY"),
      }));
    }
  },
  mounted() {
    const savedSortBy = localStorage.getItem('brandsTableSortBy');
    const savedSortDesc = localStorage.getItem('brandsTableSortDesc');

    if (savedSortBy) this.sortBy = savedSortBy;
    if (savedSortDesc !== null) this.sortDesc = savedSortDesc === 'true';
  },
  watch: {
    sortBy(newVal) {
      localStorage.setItem('brandsTableSortBy', newVal);
    },
    sortDesc(newVal) {
      localStorage.setItem('brandsTableSortDesc', newVal);
    }
  }
}
</script>
